 <!--Full width header Start-->
<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>

<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Mandatory Disclosures</h1>
      <ul>
        <li>
          <a class="active" [routerLink]="['/']">Home</a>
        </li>
        <li>Mandatory Disclosures</li>
      </ul>
    </div>
  </div>

  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 scholarships-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 mb-70">
          <div class="blog-item">
            <div class="blog-content">
              <h3 class="blog-title">Mandatory Disclosures</h3>
              <div class="blog-table-wrap">
                <iframe src="https://docs.google.com/spreadsheets/d/e/2PACX-1vRvP4_0CzGka-56kJTQno2u_OtcdF-QfkXcFF-AK0jFgNyLEJS3WdliRW9ua2sbKTKykv8hDrIjKXXi/pubhtml?widget=true&amp;headers=false"></iframe>     </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
